import * as api from '@tytapp/api';
import { Model } from '@tytapp/common';
import { Production } from '.';
import { PagedArray } from '../common';
import { Article } from './Article';

@Model('Show')
export class Show extends api.ApiShow {
    static API = api.ShowsApi;
    static ROOT_URL = '/content/shows';

    public get url() {
        return `/shows/${this.id}`;
    }
    async podcasts(offset = 0, limit = 10): Promise<PagedArray<Production>> {
        return await <any>Show.inject(api.ShowsApi)
            .getShowPodcasts(this.id, offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }

    async clips(offset = 0, limit = 10): Promise<PagedArray<Production>> {
        return await <any>Show.inject(api.ShowsApi)
            .getShowClips(this.id, offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }

    async episodes(offset = 0, limit = 10): Promise<PagedArray<Production>> {
        return await <any>Show.inject(api.ShowsApi)
            .getShowEpisodes(this.id, offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }

    async articles(offset = 0, limit = 10): Promise<PagedArray<Article>> {
        return await <any>Show.inject(api.ShowsApi)
            .getShowArticles(this.id, offset, limit)
            .toPromise()
            .catch(response => { throw response.json(); })
    }
}
